/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as ChangePasswordRouteImport } from './routes/change-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAthleteManagerRouteImport } from './routes/_app/athlete-manager'
import { Route as AppFeaturedVideoRouteImport } from './routes/_app/featured-video'
import { Route as AppMedalsRouteImport } from './routes/_app/medals'
import { Route as AppOfficialsRouteImport } from './routes/_app/officials'
import { Route as AppParaSupportRouteImport } from './routes/_app/para-support'
import { Route as AppRecordsRouteImport } from './routes/_app/records'
import { Route as AppReportsRouteImport } from './routes/_app/reports'
import { Route as AppAthletesIndexRouteImport } from './routes/_app/athletes.index'
import { Route as AppAthletesPersonIdRouteImport } from './routes/_app/athletes.$personId'
import { Route as AppMeetsIndexRouteImport } from './routes/_app/meets.index'
import { Route as AppNocsIndexRouteImport } from './routes/_app/nocs.index'
import { Route as AppNocsNocIdRouteImport } from './routes/_app/nocs.$nocId'
import { Route as AppPhasesPhaseIdRouteImport } from './routes/_app/phases.$phaseId'
import { Route as AppSportsSportIdRouteImport } from './routes/_app/sports.$sportId'
import { Route as AppTeamsIndexRouteImport } from './routes/_app/teams.index'
import { Route as AppTeamsCompetitorIdRouteImport } from './routes/_app/teams.$competitorId'
import { Route as AppMeetsMeetIdIndexRouteImport } from './routes/_app/meets.$meetId.index'
import { Route as AppMeetsMeetIdStartListRouteImport } from './routes/_app/meets.$meetId.start-list'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const ChangePasswordRoute = ChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAthleteManagerRoute = AppAthleteManagerRouteImport.update({
  id: '/athlete-manager',
  path: '/athlete-manager',
  getParentRoute: () => AppRoute,
} as any)
const AppFeaturedVideoRoute = AppFeaturedVideoRouteImport.update({
  id: '/featured-video',
  path: '/featured-video',
  getParentRoute: () => AppRoute,
} as any)
const AppMedalsRoute = AppMedalsRouteImport.update({
  id: '/medals',
  path: '/medals',
  getParentRoute: () => AppRoute,
} as any)
const AppOfficialsRoute = AppOfficialsRouteImport.update({
  id: '/officials',
  path: '/officials',
  getParentRoute: () => AppRoute,
} as any)
const AppParaSupportRoute = AppParaSupportRouteImport.update({
  id: '/para-support',
  path: '/para-support',
  getParentRoute: () => AppRoute,
} as any)
const AppRecordsRoute = AppRecordsRouteImport.update({
  id: '/records',
  path: '/records',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsRoute = AppReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AppRoute,
} as any)
const AppAthletesIndexRoute = AppAthletesIndexRouteImport.update({
  id: '/athletes/',
  path: '/athletes/',
  getParentRoute: () => AppRoute,
} as any)
const AppAthletesPersonIdRoute = AppAthletesPersonIdRouteImport.update({
  id: '/athletes/$personId',
  path: '/athletes/$personId',
  getParentRoute: () => AppRoute,
} as any)
const AppMeetsIndexRoute = AppMeetsIndexRouteImport.update({
  id: '/meets/',
  path: '/meets/',
  getParentRoute: () => AppRoute,
} as any)
const AppNocsIndexRoute = AppNocsIndexRouteImport.update({
  id: '/nocs/',
  path: '/nocs/',
  getParentRoute: () => AppRoute,
} as any)
const AppNocsNocIdRoute = AppNocsNocIdRouteImport.update({
  id: '/nocs/$nocId',
  path: '/nocs/$nocId',
  getParentRoute: () => AppRoute,
} as any)
const AppPhasesPhaseIdRoute = AppPhasesPhaseIdRouteImport.update({
  id: '/phases/$phaseId',
  path: '/phases/$phaseId',
  getParentRoute: () => AppRoute,
} as any)
const AppSportsSportIdRoute = AppSportsSportIdRouteImport.update({
  id: '/sports/$sportId',
  path: '/sports/$sportId',
  getParentRoute: () => AppRoute,
} as any)
const AppTeamsIndexRoute = AppTeamsIndexRouteImport.update({
  id: '/teams/',
  path: '/teams/',
  getParentRoute: () => AppRoute,
} as any)
const AppTeamsCompetitorIdRoute = AppTeamsCompetitorIdRouteImport.update({
  id: '/teams/$competitorId',
  path: '/teams/$competitorId',
  getParentRoute: () => AppRoute,
} as any)
const AppMeetsMeetIdIndexRoute = AppMeetsMeetIdIndexRouteImport.update({
  id: '/meets/$meetId/',
  path: '/meets/$meetId/',
  getParentRoute: () => AppRoute,
} as any)
const AppMeetsMeetIdStartListRoute = AppMeetsMeetIdStartListRouteImport.update({
  id: '/meets/$meetId/start-list',
  path: '/meets/$meetId/start-list',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/change-password': typeof ChangePasswordRoute
  '/login': typeof LoginRoute
  '/athlete-manager': typeof AppAthleteManagerRoute
  '/featured-video': typeof AppFeaturedVideoRoute
  '/medals': typeof AppMedalsRoute
  '/officials': typeof AppOfficialsRoute
  '/para-support': typeof AppParaSupportRoute
  '/records': typeof AppRecordsRoute
  '/reports': typeof AppReportsRoute
  '/athletes/$personId': typeof AppAthletesPersonIdRoute
  '/nocs/$nocId': typeof AppNocsNocIdRoute
  '/phases/$phaseId': typeof AppPhasesPhaseIdRoute
  '/sports/$sportId': typeof AppSportsSportIdRoute
  '/teams/$competitorId': typeof AppTeamsCompetitorIdRoute
  '/athletes/': typeof AppAthletesIndexRoute
  '/meets/': typeof AppMeetsIndexRoute
  '/nocs/': typeof AppNocsIndexRoute
  '/teams/': typeof AppTeamsIndexRoute
  '/meets/$meetId/start-list': typeof AppMeetsMeetIdStartListRoute
  '/meets/$meetId/': typeof AppMeetsMeetIdIndexRoute
}
export interface FileRoutesByTo {
  '/change-password': typeof ChangePasswordRoute
  '/login': typeof LoginRoute
  '/athlete-manager': typeof AppAthleteManagerRoute
  '/featured-video': typeof AppFeaturedVideoRoute
  '/medals': typeof AppMedalsRoute
  '/officials': typeof AppOfficialsRoute
  '/para-support': typeof AppParaSupportRoute
  '/records': typeof AppRecordsRoute
  '/reports': typeof AppReportsRoute
  '/': typeof AppIndexRoute
  '/athletes/$personId': typeof AppAthletesPersonIdRoute
  '/nocs/$nocId': typeof AppNocsNocIdRoute
  '/phases/$phaseId': typeof AppPhasesPhaseIdRoute
  '/sports/$sportId': typeof AppSportsSportIdRoute
  '/teams/$competitorId': typeof AppTeamsCompetitorIdRoute
  '/athletes': typeof AppAthletesIndexRoute
  '/meets': typeof AppMeetsIndexRoute
  '/nocs': typeof AppNocsIndexRoute
  '/teams': typeof AppTeamsIndexRoute
  '/meets/$meetId/start-list': typeof AppMeetsMeetIdStartListRoute
  '/meets/$meetId': typeof AppMeetsMeetIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/change-password': typeof ChangePasswordRoute
  '/login': typeof LoginRoute
  '/_app/athlete-manager': typeof AppAthleteManagerRoute
  '/_app/featured-video': typeof AppFeaturedVideoRoute
  '/_app/medals': typeof AppMedalsRoute
  '/_app/officials': typeof AppOfficialsRoute
  '/_app/para-support': typeof AppParaSupportRoute
  '/_app/records': typeof AppRecordsRoute
  '/_app/reports': typeof AppReportsRoute
  '/_app/': typeof AppIndexRoute
  '/_app/athletes/$personId': typeof AppAthletesPersonIdRoute
  '/_app/nocs/$nocId': typeof AppNocsNocIdRoute
  '/_app/phases/$phaseId': typeof AppPhasesPhaseIdRoute
  '/_app/sports/$sportId': typeof AppSportsSportIdRoute
  '/_app/teams/$competitorId': typeof AppTeamsCompetitorIdRoute
  '/_app/athletes/': typeof AppAthletesIndexRoute
  '/_app/meets/': typeof AppMeetsIndexRoute
  '/_app/nocs/': typeof AppNocsIndexRoute
  '/_app/teams/': typeof AppTeamsIndexRoute
  '/_app/meets/$meetId/start-list': typeof AppMeetsMeetIdStartListRoute
  '/_app/meets/$meetId/': typeof AppMeetsMeetIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/change-password'
    | '/login'
    | '/athlete-manager'
    | '/featured-video'
    | '/medals'
    | '/officials'
    | '/para-support'
    | '/records'
    | '/reports'
    | '/athletes/$personId'
    | '/nocs/$nocId'
    | '/phases/$phaseId'
    | '/sports/$sportId'
    | '/teams/$competitorId'
    | '/athletes/'
    | '/meets/'
    | '/nocs/'
    | '/teams/'
    | '/meets/$meetId/start-list'
    | '/meets/$meetId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/change-password'
    | '/login'
    | '/athlete-manager'
    | '/featured-video'
    | '/medals'
    | '/officials'
    | '/para-support'
    | '/records'
    | '/reports'
    | '/'
    | '/athletes/$personId'
    | '/nocs/$nocId'
    | '/phases/$phaseId'
    | '/sports/$sportId'
    | '/teams/$competitorId'
    | '/athletes'
    | '/meets'
    | '/nocs'
    | '/teams'
    | '/meets/$meetId/start-list'
    | '/meets/$meetId'
  id:
    | '__root__'
    | '/_app'
    | '/change-password'
    | '/login'
    | '/_app/athlete-manager'
    | '/_app/featured-video'
    | '/_app/medals'
    | '/_app/officials'
    | '/_app/para-support'
    | '/_app/records'
    | '/_app/reports'
    | '/_app/'
    | '/_app/athletes/$personId'
    | '/_app/nocs/$nocId'
    | '/_app/phases/$phaseId'
    | '/_app/sports/$sportId'
    | '/_app/teams/$competitorId'
    | '/_app/athletes/'
    | '/_app/meets/'
    | '/_app/nocs/'
    | '/_app/teams/'
    | '/_app/meets/$meetId/start-list'
    | '/_app/meets/$meetId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  ChangePasswordRoute: typeof ChangePasswordRoute
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/change-password': {
      id: '/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof ChangePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/athlete-manager': {
      id: '/_app/athlete-manager'
      path: '/athlete-manager'
      fullPath: '/athlete-manager'
      preLoaderRoute: typeof AppAthleteManagerRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/featured-video': {
      id: '/_app/featured-video'
      path: '/featured-video'
      fullPath: '/featured-video'
      preLoaderRoute: typeof AppFeaturedVideoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/medals': {
      id: '/_app/medals'
      path: '/medals'
      fullPath: '/medals'
      preLoaderRoute: typeof AppMedalsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/officials': {
      id: '/_app/officials'
      path: '/officials'
      fullPath: '/officials'
      preLoaderRoute: typeof AppOfficialsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/para-support': {
      id: '/_app/para-support'
      path: '/para-support'
      fullPath: '/para-support'
      preLoaderRoute: typeof AppParaSupportRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/records': {
      id: '/_app/records'
      path: '/records'
      fullPath: '/records'
      preLoaderRoute: typeof AppRecordsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports': {
      id: '/_app/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AppReportsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/athletes/': {
      id: '/_app/athletes/'
      path: '/athletes'
      fullPath: '/athletes/'
      preLoaderRoute: typeof AppAthletesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/athletes/$personId': {
      id: '/_app/athletes/$personId'
      path: '/athletes/$personId'
      fullPath: '/athletes/$personId'
      preLoaderRoute: typeof AppAthletesPersonIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/meets/': {
      id: '/_app/meets/'
      path: '/meets'
      fullPath: '/meets/'
      preLoaderRoute: typeof AppMeetsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/nocs/': {
      id: '/_app/nocs/'
      path: '/nocs'
      fullPath: '/nocs/'
      preLoaderRoute: typeof AppNocsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/nocs/$nocId': {
      id: '/_app/nocs/$nocId'
      path: '/nocs/$nocId'
      fullPath: '/nocs/$nocId'
      preLoaderRoute: typeof AppNocsNocIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/phases/$phaseId': {
      id: '/_app/phases/$phaseId'
      path: '/phases/$phaseId'
      fullPath: '/phases/$phaseId'
      preLoaderRoute: typeof AppPhasesPhaseIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sports/$sportId': {
      id: '/_app/sports/$sportId'
      path: '/sports/$sportId'
      fullPath: '/sports/$sportId'
      preLoaderRoute: typeof AppSportsSportIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/teams/': {
      id: '/_app/teams/'
      path: '/teams'
      fullPath: '/teams/'
      preLoaderRoute: typeof AppTeamsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/teams/$competitorId': {
      id: '/_app/teams/$competitorId'
      path: '/teams/$competitorId'
      fullPath: '/teams/$competitorId'
      preLoaderRoute: typeof AppTeamsCompetitorIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/meets/$meetId/': {
      id: '/_app/meets/$meetId/'
      path: '/meets/$meetId'
      fullPath: '/meets/$meetId/'
      preLoaderRoute: typeof AppMeetsMeetIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/meets/$meetId/start-list': {
      id: '/_app/meets/$meetId/start-list'
      path: '/meets/$meetId/start-list'
      fullPath: '/meets/$meetId/start-list'
      preLoaderRoute: typeof AppMeetsMeetIdStartListRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAthleteManagerRoute: typeof AppAthleteManagerRoute
  AppFeaturedVideoRoute: typeof AppFeaturedVideoRoute
  AppMedalsRoute: typeof AppMedalsRoute
  AppOfficialsRoute: typeof AppOfficialsRoute
  AppParaSupportRoute: typeof AppParaSupportRoute
  AppRecordsRoute: typeof AppRecordsRoute
  AppReportsRoute: typeof AppReportsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAthletesPersonIdRoute: typeof AppAthletesPersonIdRoute
  AppNocsNocIdRoute: typeof AppNocsNocIdRoute
  AppPhasesPhaseIdRoute: typeof AppPhasesPhaseIdRoute
  AppSportsSportIdRoute: typeof AppSportsSportIdRoute
  AppTeamsCompetitorIdRoute: typeof AppTeamsCompetitorIdRoute
  AppAthletesIndexRoute: typeof AppAthletesIndexRoute
  AppMeetsIndexRoute: typeof AppMeetsIndexRoute
  AppNocsIndexRoute: typeof AppNocsIndexRoute
  AppTeamsIndexRoute: typeof AppTeamsIndexRoute
  AppMeetsMeetIdStartListRoute: typeof AppMeetsMeetIdStartListRoute
  AppMeetsMeetIdIndexRoute: typeof AppMeetsMeetIdIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAthleteManagerRoute: AppAthleteManagerRoute,
  AppFeaturedVideoRoute: AppFeaturedVideoRoute,
  AppMedalsRoute: AppMedalsRoute,
  AppOfficialsRoute: AppOfficialsRoute,
  AppParaSupportRoute: AppParaSupportRoute,
  AppRecordsRoute: AppRecordsRoute,
  AppReportsRoute: AppReportsRoute,
  AppIndexRoute: AppIndexRoute,
  AppAthletesPersonIdRoute: AppAthletesPersonIdRoute,
  AppNocsNocIdRoute: AppNocsNocIdRoute,
  AppPhasesPhaseIdRoute: AppPhasesPhaseIdRoute,
  AppSportsSportIdRoute: AppSportsSportIdRoute,
  AppTeamsCompetitorIdRoute: AppTeamsCompetitorIdRoute,
  AppAthletesIndexRoute: AppAthletesIndexRoute,
  AppMeetsIndexRoute: AppMeetsIndexRoute,
  AppNocsIndexRoute: AppNocsIndexRoute,
  AppTeamsIndexRoute: AppTeamsIndexRoute,
  AppMeetsMeetIdStartListRoute: AppMeetsMeetIdStartListRoute,
  AppMeetsMeetIdIndexRoute: AppMeetsMeetIdIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  ChangePasswordRoute: ChangePasswordRoute,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
